var ValidationReasons = /* @__PURE__ */ ((ValidationReasons2) => (ValidationReasons2.StreetAddress = "NO_STREET_ADDRESS", ValidationReasons2.Route = "STREET_ADDRESS_NO_ROUTE", ValidationReasons2.StreetNumber = "STREET_ADDRESS_NO_STREET_NUMBER", ValidationReasons2.City = "NO_CITY", ValidationReasons2.State = "NO_STATE", ValidationReasons2.PostalCode = "NO_POSTAL_CODE", ValidationReasons2.Country = "NOT_THE_USA", ValidationReasons2))(ValidationReasons || {});
export {
  ValidationReasons
};
//# sourceMappingURL=ValidationReasons.js.map
